import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 16a4.51 4.51 0 0 0 4.5-4.5v-7a4.5 4.5 0 0 0-9 0v7A4.51 4.51 0 0 0 12 16Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 8a1 1 0 0 0-1 1v2.5a6 6 0 0 1-12 0V9a1 1 0 0 0-2 0v2.5a8 8 0 0 0 6.79 7.91.25.25 0 0 1 .21.24V23a1 1 0 0 0 2 0v-3.35a.25.25 0 0 1 .21-.24A8 8 0 0 0 20 11.5V9a1 1 0 0 0-1-1Z"
})), 'MicrophoneAlternate');